import { render, staticRenderFns } from "./InsPage.vue?vue&type=template&id=7349fbb5&scoped=true"
import script from "./InsPage.vue?vue&type=script&lang=ts"
export * from "./InsPage.vue?vue&type=script&lang=ts"
import style0 from "./InsPage.vue?vue&type=style&index=0&id=7349fbb5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7349fbb5",
  null
  
)

export default component.exports